import { useRootData } from "~/hooks/use-root-data";

import { useQueryClient } from "@tanstack/react-query";

/**
 * Hook for retrieving shared properties for all push hooks, such as whether the feature is enabled or not, the query key, etc.
 */

export const PUSH_SUBSCRIPTION_QUERY_KEY = "push-subscription";

export const useSharedPushUtils = () => {
  const rootData = useRootData();
  const queryClient = useQueryClient();

  const queryKey = [
    PUSH_SUBSCRIPTION_QUERY_KEY,
    rootData?.user?.employeeId,
  ] as const;

  return {
    /**
     * Shared query key, so that invalidation works across all push hooks.
     */
    queryKey,

    /**
     * The VAPID public key, used for subscribing to push notifications.
     */
    vapidPublicKey: rootData?.vapidPublicKey,

    /**
     * Invalidates the query for the current user's push subscription. Nice way to recalculate it after (un)subscribing.
     */
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey,
      }),
  };
};
